import { render } from "./Redeem.vue?vue&type=template&id=f0c7031c&scoped=true"
import script from "./Redeem.vue?vue&type=script&lang=js"
export * from "./Redeem.vue?vue&type=script&lang=js"

import "./Redeem.vue?vue&type=style&index=0&id=f0c7031c&scoped=true&lang=scss"

import exportComponent from "/Users/jiangxin/xhw/outer-h5-gwj-nft-website-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c7031c"]])

export default __exports__